import { Component } from "@angular/core";
import { ControlContainer, NgModelGroup } from "@angular/forms";
import { MetadataInputTextComponent } from "./metadata-input-text.component";

@Component({
    selector: "metadata-input-text-area",
    templateUrl: "./metadata-input-textarea.tmpl.html",
    viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }],
    standalone: false
})
export class MetadataInputTextAreaComponent extends MetadataInputTextComponent
{

}
